import React, { useState } from 'react';
import {
  LightboxContainer,
  LightboxOverlay,
  LightboxContent,
  MainImage,
  CloseButton,
  NavButton,
  ThumbnailStrip,
  Thumbnail,
  ImageCounter,
  ZoomControls,
  ZoomButton
} from './style';

const ImageLightbox = ({ images, initialIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [zoom, setZoom] = useState(1);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    setZoom(1);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    setZoom(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowLeft') handlePrevious();
    if (e.key === 'ArrowRight') handleNext();
  };

  const handleZoomIn = () => {
    setZoom((prev) => Math.min(prev + 0.5, 3));
  };

  const handleZoomOut = () => {
    setZoom((prev) => Math.max(prev - 0.5, 0.5));
  };

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LightboxContainer>
      <LightboxOverlay onClick={onClose} />
      
      <LightboxContent>
        <CloseButton onClick={onClose}>×</CloseButton>
        
        <ImageCounter>
          {currentIndex + 1} / {images.length}
        </ImageCounter>

        <ZoomControls>
          <ZoomButton onClick={handleZoomOut} disabled={zoom <= 0.5}>
            −
          </ZoomButton>
          <span>{Math.round(zoom * 100)}%</span>
          <ZoomButton onClick={handleZoomIn} disabled={zoom >= 3}>
            +
          </ZoomButton>
        </ZoomControls>

        {images.length > 1 && (
          <>
            <NavButton direction="left" onClick={handlePrevious}>
              ‹
            </NavButton>
            <NavButton direction="right" onClick={handleNext}>
              ›
            </NavButton>
          </>
        )}

        <div style={{ 
          overflow: zoom > 1 ? 'auto' : 'hidden', 
          maxHeight: '80vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <MainImage
            src={images[currentIndex]}
            alt={`Image ${currentIndex + 1}`}
            style={{ transform: `scale(${zoom})` }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>

        {images.length > 1 && (
          <ThumbnailStrip>
            {images.map((image, index) => (
              <Thumbnail
                key={index}
                src={image}
                alt={`Thumbnail ${index + 1}`}
                active={index === currentIndex}
                onClick={() => {
                  setCurrentIndex(index);
                  setZoom(1);
                }}
              />
            ))}
          </ThumbnailStrip>
        )}
      </LightboxContent>
    </LightboxContainer>
  );
};

export default ImageLightbox;
